// Publications list.
// To add a new paper, append an object to this array. Fields:
//   authors  - full author string as it appears in the citation
//   title    - paper title (no surrounding quotes)
//   venue    - journal / conference name
//   pages    - page range, e.g. "235–249" (optional)
//   year     - publication year (used for sorting; newest first)
//   month    - optional month label, e.g. "Jan." (display only)
//   doi      - full DOI URL (used for the [DOI] link)
// The author name to highlight (bold) across all entries:
export const HIGHLIGHT_AUTHOR = "Ghosh";

export const publicationsData = [
  {
    authors:"A. K. Ghosh, M. M. Hasan, M. N. Sakib, A. M. Nayeem, M. Asaduzzaman, and Md. A. H. Kafi",
    title: "Adaptive Explanation-Aware Stacking for Cervical Cancer Risk Prediction",
    venue: "Advances in Intelligent Systems Research",
    pages: "235–249",
    year: 2026,
    doi: "https://doi.org/10.2991/978-94-6239-664-7_18",
  },
  {
    authors: "A. K. Ghosh, M. H. Akther, S. Marjan, and Md. M. I. Mithu",
    title:"High-Accuracy 3-Class Cerebral Stroke Detection Using ConvNeXt: An End-to-End Vision Pipeline",
    venue: "Advances in Intelligent Systems Research",
    pages: "133–144",
    year: 2026,
    doi: "https://doi.org/10.2991/978-94-6239-664-7_11",
  },
  {
    authors:"S. Marjan, A. K. Bristy, A. Kumar Ghosh, D. Bhowmik, R. A. Nayeem, and Md. M. I. Mithu",
    title:"Lightweight Graph Attention Network-Based Framework for Intelligent Frangipani Leaf Disease Classification",
    venue:"2026 5th International Conference on Electrical, Computer & Telecommunication Engineering (ICECTE)",
    pages: "1–6",
    year: 2026,
    month: "Jan.",
    doi: "https://doi.org/10.1109/icecte69292.2026.11429347",
  },
  {
    authors:"A. K. Ghosh, M. M. Kabir, S. Marjan, D. Bhowmik, R. A. Nayeem, and M. Assaduzzaman",
    title:"YOLO-E3CA: An Ensemble YOLOv8 Framework with Coordinate Attention for Automated Detection of Karanda (Carissa carandas) Leaf Diseases",
    venue: "Advances in Intelligent Systems Research",
    pages: "857–871",
    year: 2026,
    doi: "https://doi.org/10.2991/978-94-6239-664-7_59",
  },
  {
    authors:
      "A. K. Ghosh, S. Marjan, R. A. Nayeem, S. M. A. Al Muhib, Md. H. I. Bijoy, and M. H. Islam",
    title: "Machine Learning-Based Typhoid Prediction Using Clinical Data",
    venue:
      "2025 IEEE 4th International Conference on Robotics, Automation, Artificial-Intelligence and Internet-of-Things (RAAICON)",
    pages: "537–542",
    year: 2025,
    month: "Nov.",
    doi: "https://doi.org/10.1109/raaicon69033.2025.11502444",
  },
];
